import { useMutation, useQueryClient } from "react-query";
import { WorkspaceAddFilesData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useAddWorkspaceFilesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceAddFilesData) => workspaceService.addFiles(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
      },
    }
  );
};
